import { Dropdown as AntdDropdown } from "@empglabs/backoffice-ui-kit"

const Dropdown = props => {
  return <AntdDropdown {...props} />
}

export default Dropdown
